import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import UseSeal from '@/types/table/useSeal';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface UseSealData extends UseSeal {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class UseSealController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<UseSealData>>(API_CONTEXT + '/app/useSeal/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<UseSealData>(API_CONTEXT + '/app/useSeal/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/useSeal/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/useSeal/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/useSeal/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/deleteBatch', params, httpOptions);
  }
  static startOnlyUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/startOnly/useSeal', params, httpOptions);
  }
  static startWithBusinessKeyUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/startWithBusinessKey/useSeal', params, httpOptions);
  }
  static startAndTakeUserTaskUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/startAndTakeUserTask/useSeal', params, httpOptions);
  }
  static startAndSaveDraftUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/startAndSaveDraft/useSeal', params, httpOptions);
  }
  static submitUserTaskUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/submitUserTask/useSeal', params, httpOptions);
  }
  static viewTaskBusinessDataUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/useSeal/viewTaskBusinessData/useSeal', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/useSeal/viewHistoricTaskBusinessData/useSeal', params, httpOptions);
  }
  static listWorkOrderUseSeal(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/useSeal/listWorkOrder/useSeal', params, httpOptions);
  }
   static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
}
